import { z } from 'zod'

export type ImporterFormData = {
  name: string
  customId?: string
  placeOfRegistration: string
  identificationNumber: string
  street: string
  streetNumber: string
  street2: string
  postCode: string
  city: string
  subDivision: string
  country: string
  poBox: string
}

const importerFormSchema = z.object({
  name: z.string().min(1),
  customId: z.string().optional(),
  placeOfRegistration: z.string().min(1),
  identificationNumber: z.string().min(1),
  country: z.string().min(1),
  street: z.string().optional(),
  streetNumber: z.string().optional(),
  street2: z.string().optional(),
  postCode: z.string().optional(),
  city: z.string().min(1),
  subDivision: z.string().optional(),
  poBox: z.string().optional()
})

export const validateImporterForm = (data: ImporterFormData) => {
  return importerFormSchema.safeParse(data)
}
